import { DataCard } from '../../../../components/ui';

export interface AnomalyAlertsWidgetProps {
  escalations: { data?: any };
}

export function AnomalyAlertsWidget({ escalations }: AnomalyAlertsWidgetProps) {
  const items = (escalations.data?.actions ?? []).filter((a: any) =>
    a.body?.includes('control chart') || a.title?.toLowerCase().includes('anomaly')
  );

  return (
    <DataCard
      title="Anomaly Alerts"
      subtitle="Statistical control-chart deviations (last 24h)"
    >
      {items.length === 0 ? (
        <p className="text-2xs text-ink-dim italic">No statistical anomalies. Metrics tracking within ±2σ.</p>
      ) : (
        <div className="space-y-1.5">
          {items.slice(0, 3).map((a: any) => (
            <div key={a.id} className="rounded-lg bg-warn/10 px-3 py-2 border border-warn/30">
              <p className="text-xs font-medium text-ink">{a.title}</p>
              <p className="text-2xs text-ink-dim mt-0.5">{a.body}</p>
            </div>
          ))}
        </div>
      )}
    </DataCard>
  );
}
